// filesApi.js
// Загрузка файлов через /api/files/*
// Бэкенд (FileController) отдаёт:
// { success: 1, file: { url: "<BASE_URL>/images/<uuid>.jpg" } }

import { request } from "./http";
import { API_BASE_URL } from "../config/env";
import { readAuthToken } from "../auth/authStorage";

function safeApiPath(path) {
    const value = String(path || "").trim();
    if (!value) throw new Error("API path is required");
    return value.startsWith("/") ? value : `/${value}`;
}

function parseXhrResponse(xhr) {
    const contentType = String(xhr.getResponseHeader("content-type") || "").toLowerCase();
    if (contentType.includes("application/json")) {
        try {
            return JSON.parse(xhr.responseText || "{}");
        } catch {
            return null;
        }
    }
    return xhr.responseText;
}

function uploadWithProgress(path, fieldName, file, { onProgress, withCredentials = true } = {}) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const token = readAuthToken();
        const url = `${API_BASE_URL}${safeApiPath(path)}`;
        xhr.open("POST", url, true);
        xhr.withCredentials = withCredentials;
        xhr.setRequestHeader("Accept", "application/json, text/plain, */*");
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);

        xhr.upload.onprogress = (event) => {
            if (!event || !event.lengthComputable || typeof onProgress !== "function") return;
            const pct = Math.max(0, Math.min(100, Math.round((event.loaded / event.total) * 100)));
            onProgress(pct, event.loaded, event.total);
        };

        xhr.onerror = () => reject(new Error("Ошибка сети при загрузке файла"));
        xhr.onabort = () => reject(new Error("Загрузка файла прервана"));
        xhr.onload = () => {
            const payload = parseXhrResponse(xhr);
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(payload);
                return;
            }
            const err = new Error(
                (payload && typeof payload === "object" && (payload.message || payload.error)) ||
                (typeof payload === "string" && payload) ||
                `HTTP ${xhr.status}`
            );
            err.status = xhr.status;
            if (payload && typeof payload === "object") Object.assign(err, payload);
            reject(err);
        };

        const fd = new FormData();
        fd.append(fieldName, file);
        xhr.send(fd);
    });
}

export const filesApi = {
    uploadImage(file) {
        const fd = new FormData();
        // FileController принимает image или file
        fd.append("image", file);
        return request("/api/files/upload", { method: "POST", body: fd, timeoutMs: 180000 });
    },

    uploadDocument(file) {
        const fd = new FormData();
        fd.append("document", file);
        return request("/api/files/upload-document", { method: "POST", body: fd, timeoutMs: 180000 });
    },

    uploadEducationDocument(file) {
        const fd = new FormData();
        fd.append("document", file);
        return request("/api/files/upload-document-education", { method: "POST", body: fd, timeoutMs: 180000 });
    },

    uploadAudio(file, { onProgress } = {}) {
        return uploadWithProgress("/api/files/upload-audio", "audio", file, { onProgress });
    },

    uploadFromUrl(url) {
        return request("/api/files/upload-url", { method: "POST", json: { url } });
    },
};
